// @flow
// THIS FILE IS AUTOMATICALLY GENERATED -- DO NOT EDIT

const Events: Object = {}

// props

type CGPropsCommon = {
  session_id: string,
  ...
} & $Shape<CGPropsCommon>
type CGPropsCommonAny = {
  session_id?: string,
  ...
}

type CGPropsPublicIdentityEditUsernameScreenShown = {||}

type CGPropsPublicIdentityEditUsernameFieldPressed = {||}

type CGPropsPublicIdentityEditUsernameTypingStarted = {||}

type CGPropsPublicIdentityEditUsernameBackPressed = {||}

type CGPropsPublicIdentityEditUsernameSuggestionPressed = {||}

type CGPropsPublicIdentityEditUsernameSavePressed = {||}

type CGPropsPublicIdentityEditUsernameClosePressed = {||}

type CGPropsPublicIdentityProfileScreenShown = {||}

type CGPropsPublicIdentityProfileSendPressed = {||}

type CGPropsPublicIdentityProfileRequestPressed = {||}

type CGPropsPublicIdentityProfileReportPressed = {||}

type CGPropsPublicIdentityMyProfileScreenShown = {||}

type CGPropsPublicIdentityMyProfileBackPressed = {||}

type CGPropsPublicIdentityMyProfileSharePressed = {||}

type CGPropsPublicIdentityMyProfileClosePressed = {||}

type CGPropsPublicIdentityEditProfileScreenShown = {||}

type CGPropsPublicIdentityEditProfileBackgroundPressed = {||}

type CGPropsPublicIdentityEditProfilePhotoPressed = {||}

type CGPropsPublicIdentityEditProfileUsernamePressed = {||}

type CGPropsPublicIdentityEditProfileLocationPressed = {||}

type CGPropsPublicIdentityEditProfileAboutPressed = {||}

type CGPropsPublicIdentityEditProfileStatusTogglePressed = {|
  opsel: 'y' | 'n',
|}

type CGPropsPublicIdentityEditProfileEmailTogglePressed = {|
  opsel: 'y' | 'n',
|}

type CGPropsPublicIdentityEditProfilePhoneTogglePressed = {|
  opsel: 'y' | 'n',
|}

type CGPropsPublicIdentityEditProfileTermsPressed = {||}

type CGPropsPublicIdentityEditProfileSharePressed = {||}

type CGPropsPublicIdentityEditProfileClosePressed = {||}

type CGPropsPublicIdentityHideProfileConfirmationScreenShown = {||}

type CGPropsPublicIdentityHideProfileConfirmationClosePressed = {||}

type CGPropsPublicIdentityHideProfileConfirmationTurnoffPressed = {||}

type CGPropsPublicIdentityHideProfileConfirmationCancelPressed = {||}

type CGPropsPublicIdentityHideProfileConfirmationBackPressed = {||}

type CGPropsPublicIdentityEditAboutScreenShown = {||}

type CGPropsPublicIdentityEditAboutBackPressed = {||}

type CGPropsPublicIdentityEditAboutClosePressed = {||}

type CGPropsPublicIdentityEditAboutFieldPressed = {||}

type CGPropsPublicIdentityEditAboutTypingStarted = {||}

type CGPropsPublicIdentityEditAboutSavePressed = {||}

type CGPropsPublicIdentityEditLocationScreenShown = {||}

type CGPropsPublicIdentityEditLocationBackPressed = {||}

type CGPropsPublicIdentityEditLocationCityPressed = {||}

type CGPropsPublicIdentityEditLocationStatePressed = {||}

type CGPropsPublicIdentityEditLocationDontShowPressed = {||}

type CGPropsPublicIdentityEditLocationSavePressed = {|
  opsel: 'city' | 'state' | 'none',
|}

type CGPropsPublicIdentityEditLocationClosePressed = {||}

type CGPropsPublicIdentityProfilePictureEditScreenShown = {||}

type CGPropsPublicIdentityProfilePictureEditBackPressed = {||}

type CGPropsPublicIdentityProfilePictureEditClosePressed = {||}

type CGPropsPublicIdentityProfilePictureEditChangePressed = {||}

type CGPropsPublicIdentityProfilePictureEditSavePressed = {||}

type CGPropsPublicIdentityBackgroundEditScreenShown = {||}

type CGPropsPublicIdentityBackgroundEditBackPressed = {||}

type CGPropsPublicIdentityBackgroundEditUploadPressed = {||}

type CGPropsPublicIdentityBackgroundEditClosePressed = {||}

type CGPropsPublicIdentityBackgroundAdjustScreenShown = {||}

type CGPropsPublicIdentityBackgroundAdjustBackPressed = {||}

type CGPropsPublicIdentityBackgroundAdjustSavePressed = {||}

type CGPropsPublicIdentityBackgroundAdjustClosePressed = {||}

type CGPropsPublicIdentityFailedCustomerInteractionOccurred = {|
  error_description: string,
  error_code: string,
  screen: string,
|}

type CGPropsPublicIdentityNonVisibleErrorOccurred = {|
  file_name: string,
  description: string,
  function_name: string,
|}

// common props

export let commonProps: Object = {}
Events.initCommonProps = (props: CGPropsCommon) => {
  commonProps = {
    product: 'public_identity',
    ...props,
  }
}
Events.updateCommonProps = (props: CGPropsCommonAny) => {
  commonProps = {
    ...commonProps,
    ...props,
  }
}

// events

Events.public_identity_edit_username_screen_shown = (
  props: CGPropsPublicIdentityEditUsernameScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_edit_username_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_field_pressed = (
  props: CGPropsPublicIdentityEditUsernameFieldPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_field_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_typing_started = (
  props: CGPropsPublicIdentityEditUsernameTypingStarted,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_typing_started',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_back_pressed = (
  props: CGPropsPublicIdentityEditUsernameBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_suggestion_pressed = (
  props: CGPropsPublicIdentityEditUsernameSuggestionPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_suggestion_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_save_pressed = (
  props: CGPropsPublicIdentityEditUsernameSavePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_save_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_username_close_pressed = (
  props: CGPropsPublicIdentityEditUsernameClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_username_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_screen_shown = (
  props: CGPropsPublicIdentityProfileScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_profile_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_send_pressed = (
  props: CGPropsPublicIdentityProfileSendPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_send_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_request_pressed = (
  props: CGPropsPublicIdentityProfileRequestPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_request_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_report_pressed = (
  props: CGPropsPublicIdentityProfileReportPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_report_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_my_profile_screen_shown = (
  props: CGPropsPublicIdentityMyProfileScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_my_profile_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_my_profile_back_pressed = (
  props: CGPropsPublicIdentityMyProfileBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_my_profile_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_my_profile_share_pressed = (
  props: CGPropsPublicIdentityMyProfileSharePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_my_profile_share_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_my_profile_close_pressed = (
  props: CGPropsPublicIdentityMyProfileClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_my_profile_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_screen_shown = (
  props: CGPropsPublicIdentityEditProfileScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_edit_profile_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_background_pressed = (
  props: CGPropsPublicIdentityEditProfileBackgroundPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_background_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_photo_pressed = (
  props: CGPropsPublicIdentityEditProfilePhotoPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_photo_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_username_pressed = (
  props: CGPropsPublicIdentityEditProfileUsernamePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_username_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_location_pressed = (
  props: CGPropsPublicIdentityEditProfileLocationPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_location_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_about_pressed = (
  props: CGPropsPublicIdentityEditProfileAboutPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_about_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_status_toggle_pressed = (
  props: CGPropsPublicIdentityEditProfileStatusTogglePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_status_toggle_pressed',
  event_props: 'session_id, product, event_type, opsel',
  ...props,
})

Events.public_identity_edit_profile_email_toggle_pressed = (
  props: CGPropsPublicIdentityEditProfileEmailTogglePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_email_toggle_pressed',
  event_props: 'session_id, product, event_type, opsel',
  ...props,
})

Events.public_identity_edit_profile_phone_toggle_pressed = (
  props: CGPropsPublicIdentityEditProfilePhoneTogglePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_phone_toggle_pressed',
  event_props: 'session_id, product, event_type, opsel',
  ...props,
})

Events.public_identity_edit_profile_terms_pressed = (
  props: CGPropsPublicIdentityEditProfileTermsPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_terms_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_share_pressed = (
  props: CGPropsPublicIdentityEditProfileSharePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_share_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_profile_close_pressed = (
  props: CGPropsPublicIdentityEditProfileClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_profile_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_hide_profile_confirmation_screen_shown = (
  props: CGPropsPublicIdentityHideProfileConfirmationScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_hide_profile_confirmation_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_hide_profile_confirmation_close_pressed = (
  props: CGPropsPublicIdentityHideProfileConfirmationClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_hide_profile_confirmation_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_hide_profile_confirmation_turnoff_pressed = (
  props: CGPropsPublicIdentityHideProfileConfirmationTurnoffPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_hide_profile_confirmation_turnoff_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_hide_profile_confirmation_cancel_pressed = (
  props: CGPropsPublicIdentityHideProfileConfirmationCancelPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_hide_profile_confirmation_cancel_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_hide_profile_confirmation_back_pressed = (
  props: CGPropsPublicIdentityHideProfileConfirmationBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_hide_profile_confirmation_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_screen_shown = (
  props: CGPropsPublicIdentityEditAboutScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_edit_about_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_back_pressed = (
  props: CGPropsPublicIdentityEditAboutBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_about_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_close_pressed = (
  props: CGPropsPublicIdentityEditAboutClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_about_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_field_pressed = (
  props: CGPropsPublicIdentityEditAboutFieldPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_about_field_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_typing_started = (
  props: CGPropsPublicIdentityEditAboutTypingStarted,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_about_typing_started',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_about_save_pressed = (
  props: CGPropsPublicIdentityEditAboutSavePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_about_save_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_screen_shown = (
  props: CGPropsPublicIdentityEditLocationScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_edit_location_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_back_pressed = (
  props: CGPropsPublicIdentityEditLocationBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_city_pressed = (
  props: CGPropsPublicIdentityEditLocationCityPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_city_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_state_pressed = (
  props: CGPropsPublicIdentityEditLocationStatePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_state_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_dont_show_pressed = (
  props: CGPropsPublicIdentityEditLocationDontShowPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_dont_show_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_edit_location_save_pressed = (
  props: CGPropsPublicIdentityEditLocationSavePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_save_pressed',
  event_props: 'session_id, product, event_type, opsel',
  ...props,
})

Events.public_identity_edit_location_close_pressed = (
  props: CGPropsPublicIdentityEditLocationClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_edit_location_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_picture_edit_screen_shown = (
  props: CGPropsPublicIdentityProfilePictureEditScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_profile_picture_edit_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_picture_edit_back_pressed = (
  props: CGPropsPublicIdentityProfilePictureEditBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_picture_edit_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_picture_edit_close_pressed = (
  props: CGPropsPublicIdentityProfilePictureEditClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_picture_edit_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_picture_edit_change_pressed = (
  props: CGPropsPublicIdentityProfilePictureEditChangePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_picture_edit_change_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_profile_picture_edit_save_pressed = (
  props: CGPropsPublicIdentityProfilePictureEditSavePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_profile_picture_edit_save_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_edit_screen_shown = (
  props: CGPropsPublicIdentityBackgroundEditScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_background_edit_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_edit_back_pressed = (
  props: CGPropsPublicIdentityBackgroundEditBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_edit_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_edit_upload_pressed = (
  props: CGPropsPublicIdentityBackgroundEditUploadPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_edit_upload_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_edit_close_pressed = (
  props: CGPropsPublicIdentityBackgroundEditClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_edit_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_adjust_screen_shown = (
  props: CGPropsPublicIdentityBackgroundAdjustScreenShown,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_background_adjust_screen_shown',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_adjust_back_pressed = (
  props: CGPropsPublicIdentityBackgroundAdjustBackPressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_adjust_back_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_adjust_save_pressed = (
  props: CGPropsPublicIdentityBackgroundAdjustSavePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_adjust_save_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_background_adjust_close_pressed = (
  props: CGPropsPublicIdentityBackgroundAdjustClosePressed,
) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'public_identity_background_adjust_close_pressed',
  event_props: 'session_id, product, event_type',
  ...props,
})

Events.public_identity_failed_customer_interaction_occurred = (
  props: CGPropsPublicIdentityFailedCustomerInteractionOccurred,
) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'public_identity_failed_customer_interaction_occurred',
  event_props:
    'session_id, product, event_type, error_code, error_description, screen',
  ...props,
})

Events.public_identity_non_visible_error_occurred = (
  props: CGPropsPublicIdentityNonVisibleErrorOccurred,
) => ({
  ...commonProps,
  event_type: 'err',
  event_name: 'public_identity_non_visible_error_occurred',
  event_props:
    'session_id, product, event_type, file_name, function_name, description',
  ...props,
})

// export

export default Events
